export default {
  created() {
    // 保留其他功能跳转过来的answerId
    const aId = this.$route.query.answerId
    if (aId) {
      // 打开弹层
      this.openDetail(aId, true)
    }
  }
}
